module.exports = __webpack_public_path__ + "img/a012_3.7135eff2.jpeg";